<template>
	<div class="condensed-top-bar">
		<a :href="homepageUrl" target="_blank" class="topbar-logo-link">
			<img src="/images/pronto/embedded-logo.svg" alt="Pronto logo" />
		</a>

		<div v-if="isWrapper" class="topbar-actions">
			<button
				class="topbar-action-btn"
				@click="openPopout()"
				:title="$t('common_button_popout')"
				:aria-label="$t('common_button_popout')"
			>
				<ArrowUpRightFromSquareIcon type="solid" />
			</button>

			<button
				class="topbar-action-btn"
				@click="closeWrapper()"
				:title="$t('common_button_close')"
				:aria-label="$t('common_button_close')"
			>
				<CloseIcon type="solid" class="close-icon" />
			</button>
		</div>
	</div>
</template>

<script setup>
import { computed } from 'vue'
import store from '@/store'
import { ArrowUpRightFromSquareIcon, CloseIcon } from '@/icons'
import { openPopout, postFromIframe } from '@/helpers/utils'

const homepageUrl = computed(() => {
	return store.config.wrapper ? 'https://pronto.io' : window.location.origin
})

const isWrapper = computed(() => {
	return store.config.wrapper
})

function closeWrapper() {
	if (store.config.wrapper) {
		postFromIframe({ type: 'closeWrapper' })
	} else {
		window.close()
	}
}
</script>

<style lang="scss" scoped>
@import 'src/sass/variables';

.condensed-top-bar {
	display: flex;
	align-items: center;
	justify-content: space-between;
	height: 36px;
	padding: 0 12px;
	background-color: var(--neutral-100);
	border-bottom: solid 1px var(--neutral-40040);
	position: relative;
	z-index: 101;
}

.topbar-logo-link {
	display: flex;
	align-items: center;
	text-decoration: none;

	img {
		height: 20px;
		width: auto;
	}
}

.topbar-actions {
	display: flex;
	align-items: center;
	gap: 8px;
}

.topbar-action-btn {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 26px;
	height: 26px;
	padding: 0;
	background: none;
	border: none;
	border-radius: 4px;
	cursor: pointer;
	color: var(--neutral-500);
	transition: background-color 0.15s ease;

	.pronto-icon {
		font-size: 15px;
		color: var(--neutral-500);
		&:hover {
			color: var(--neutral-400);
		}
		&:active {
			color: var(--neutral-600);
		}
	}

	.close-icon {
		font-size: 21px;
	}
}
</style>
